import { servicesApi, blogApi } from '../lib/api';

export async function generateSitemap() {
  const baseUrl = import.meta.env.VITE_APP_URL || 'https://yurdusev.com';
  
  const staticPages = [
    '',
    '/hakkimizda',
    '/cozumler',
    '/blog',
    '/iletisim',
  ];

  // Fetch dynamic routes
  let serviceSlugs: string[] = [];
  let blogSlugs: string[] = [];

  try {
    const services = await servicesApi.getAll(true);
    serviceSlugs = services.data.map((s: any) => `/cozumler/${s.slug}`);
  } catch (error) {
    console.error('Error fetching services for sitemap:', error);
  }

  try {
    const blogPosts = await blogApi.getAll(true);
    blogSlugs = blogPosts.data.map((p: any) => `/blog/${p.slug}`);
  } catch (error) {
    console.error('Error fetching blog posts for sitemap:', error);
  }

  const allPages = [
    ...staticPages,
    ...serviceSlugs,
    ...blogSlugs,
  ];

  const sitemap = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${allPages
  .map(
    (page) => `  <url>
    <loc>${baseUrl}${page}</loc>
    <lastmod>${new Date().toISOString()}</lastmod>
    <changefreq>weekly</changefreq>
    <priority>${page === '' ? '1.0' : '0.8'}</priority>
  </url>`,
  )
  .join('\n')}
</urlset>`;

  return sitemap;
}

